// @generated by TypeGen from LogbookApi/ApiRuntime - DO NOT EDIT

import type { IAccountUserLevel } from "../LogbookModel/AccountUser"
import type { IShipUserLevel } from "../LogbookModel/ShipUser"

export type ApiTarget = "app" | "server";

export interface ApiClient {
  readonly target: ApiTarget;
  call<R>(key: string, args: unknown): Promise<R>;
  url(key: string, args: unknown): string;
}

export class ApiTargetError extends Error {
  constructor(
    readonly key: string,
    readonly target: ApiTarget,
    readonly allowed: readonly ApiTarget[],
  ) {
    super(`Route ${key} is not available on target "${target}" (allowed: ${allowed.join(", ")})`);
    this.name = "ApiTargetError";
  }
}

export function assertTarget(client: ApiClient, key: string, allowed: readonly ApiTarget[]): void {
  if (!allowed.includes(client.target)) {
    throw new ApiTargetError(key, client.target, allowed);
  }
}

export interface ApiUser {
  accountLevel(accountId?: number): IAccountUserLevel | undefined;
  shipLevel(shipId?: number): IShipUserLevel | undefined;
}

export type Simplify<T> = { [K in keyof T]: T[K] } & {};

export type ApiArgs<E, K extends keyof E> = Simplify<
  { params: E[K] extends { params: infer P } ? P : {} } &
  { query?: E[K] extends { query: infer Q } ? Q : {} } &
  ([E[K] extends { request: infer B } ? B : never] extends [never]
    ? {}
    : { body: E[K] extends { request: infer B } ? B : never })
>;
